<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <div class="form-group row my-2 items-center">
      <span class="prepend col-6"
        >{{ t("vendor-metrics-popup.select_the_vendor_metrics", [modalData.accountMarketplace.accountName]) }}
      </span>
      <div class="col-6">
        <button
          iButton
          class="mx-2"
          [variant]="modalData.accountMarketplace.useSourcingMetrics ? 'main' : 'secondary'"
          type="submit"
          size="md"
          (click)="updateVendorMetrics(true)"
        >
          {{ t("vendor-metrics-popup.sourcing") }}
        </button>

        <button
          iButton
          class="mx-2"
          [variant]="modalData.accountMarketplace.useSourcingMetrics ? 'secondary' : 'main'"
          type="submit"
          size="md"
          (click)="updateVendorMetrics(false)"
        >
          {{ t("vendor-metrics-popup.manufacturing") }}
        </button>
      </div>
    </div>
  </div>
  <div class="flex justify-end gap-2">
    <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>
  </div>
</ng-container>
